import {useEffect, useMemo, useRef, useState} from 'react'
import {useAuth} from '../auth'
import {collection, getDocs, orderBy, query, where} from 'firebase/firestore'
import {fbsdb} from '../../utils/firebase'
import {KTSVG, toAbsoluteUrl, useDebounce} from '../../../_metronic/helpers'
import CustomPagination from '../user-management/users-list/Pagination'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {Button, Spinner} from 'react-bootstrap'

let PageSize = 20

const ECPClientList: React.FC = () => {
  const params = useParams()
  const eid = params.id ? params.id.toString() : undefined
  const {currentUser} = useAuth()
  const init: any[] = []
  const [data, setData] = useState(init)
  const raws = useRef(init)
  const navigate = useNavigate()
  const [ecpUsers, setECPUsers] = useState(init)
  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState<string>('')
  const debouncedSearchTerm = useDebounce(searchTerm, 500)

  const loadECPUsers = async (eid: string) => {
    let q = await getDocs(query(collection(fbsdb, 'users_shop'), where('shopId', '==', eid)))

    const objList: any[] = q.docs.map((doc: any) => {
      const obj = doc.data() as any
      obj.id = doc.id

      return obj
    })

    raws.current = objList
    filterUser()
  }

  const filterUser = () => {
    setIsLoading(true)
    if (debouncedSearchTerm) {
      const fd = raws.current.filter((u) => {
        return (
          u.name.toLowerCase().indexOf(debouncedSearchTerm.toLowerCase()) > -1 ||
          u.username.toLowerCase().indexOf(debouncedSearchTerm.toLowerCase()) > -1
        )
      })

      setData(fd)
    } else {
      setData(raws.current)
    }
    setIsLoading(false)
  }

  useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize
    const lastPageIndex = firstPageIndex + PageSize
    setECPUsers(data.slice(firstPageIndex, lastPageIndex))
    setIsLoading(false)
  }, [currentPage, data])

  useEffect(() => {
    if (eid) {
      setIsLoading(true)
      loadECPUsers(eid)
    }
  }, [])

  return (
    <>
      <div className={`card mb-5 mb-xl-8`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <div className='card-title align-items-start flex-column'>
            <div className='d-flex align-items-center position-relative my-1'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-300px ps-14 me-3'
                placeholder='Search by name / username'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {isLoading && <Spinner animation='border' variant='warning' size='sm' />}
            </div>
          </div>
          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a user'
          >
            <Button className='btn btn-sm btn-light-primary' onClick={() => navigate('/users/new')}>
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              New User
            </Button>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-150px'>Name / Username</th>
                  <th className='min-w-100px'>Role</th>
                  <th className='min-w-120px'>Delivery Area</th>
                  <th className='min-w-120px'>Department</th>
                  <th className='min-w-120px'>Organization</th>
                  <th className='min-w-100px text-end'>Actions</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {ecpUsers.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='symbol symbol-45px me-5'>
                          <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='' />
                        </div>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold text-hover-primary fs-6'></span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='text-dark fw-bold d-block fs-6'></div>
                    </td>
                    <td>
                      <div className='text-dark fw-bold d-block fs-6'>
                        {user.deliveryAreaCode ? user.deliveryAreaCode : '-'}
                      </div>
                    </td>
                    <td>
                      <div className='text-dark fw-bold d-block fs-6'>
                        {user.departmentName ? user.departmentName : '-'}
                      </div>
                    </td>
                    <td>
                      <div className='text-dark fw-bold d-block fs-6'>
                        {user.organizationName ? user.organizationName : '-'}
                      </div>
                    </td>
                    <td>
                      <div className='d-flex justify-content-end flex-shrink-0'>
                        {user.role === 'driver' && (
                          <Link
                            className='btn btn-icon btn-warning btn-sm me-1'
                            to={`/reports/performance/driver/${user.id}`}
                          >
                            <KTSVG
                              path='/media/icons/duotune/graphs/gra001.svg'
                              className='svg-icon-3'
                            />
                          </Link>
                        )}

                        {/* <a
                          href='#'
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen027.svg'
                            className='svg-icon-3'
                          />
                        </a> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              {/* end::Table body */}
            </table>

            <CustomPagination
              currentPage={currentPage}
              totalCount={data.length}
              pageSize={PageSize}
              onPageChange={(page: number) => setCurrentPage(page)}
            />
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        </div>
        {/* begin::Body */}
      </div>
    </>
  )
}

export default ECPClientList
